import { DefaultRootState } from "stores";
import { getUid } from "../app.user/selectors";
import { getJoinedMessageGroups } from "../entities.rooms/selectors";
import { getDisplayRoomMemberDirectMessageTabs } from "../app.state/selectors";

export const getRoomMessageTabOrders = (state: DefaultRootState) => {
  return state.entities.roomMessageTabOrders.entities;
};

export const getRoomMessageTabOrderById = (
  state: DefaultRootState,
  uid: string
) => {
  return (
    state.entities.roomMessageTabOrders.entities[uid]?.messageTabGroups ?? []
  );
};

export const getJoinedMessageOrder = (state: DefaultRootState) => {
  const uid = getUid(state);
  if (!uid) return [];
  const defaultTabs = ["info", "other"];
  const directMessageKeys = getDisplayRoomMemberDirectMessageTabs(state).map(
    (dm) => dm.key
  );
  const joinedMessageGroupKeys = getJoinedMessageGroups(state).map(
    (group) => group.id
  );
  const roomMessageTabOrder = getRoomMessageTabOrderById(state, uid);
  const tabKeys = [
    ...defaultTabs,
    ...directMessageKeys,
    ...joinedMessageGroupKeys,
  ];

  const notIncludeKeys = tabKeys.filter(
    (tab) => !roomMessageTabOrder.includes(tab)
  );

  const result = [...roomMessageTabOrder, ...notIncludeKeys];
  return result;
};
